export const TEMPLATE_PLACEHOLDER_LINK = 'withjoy.com/name-and-name';
